import React from 'react'
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap'

const T = ({value, handleToggle, options, lowercase}) => {
  return (
    <ToggleButtonGroup
      type="radio" bsSize="xsmall" name="options"
      value={value} 
      onChange={handleToggle}>
      {options.map((o,i)=>{
        const cap = o.charAt(0).toUpperCase() + o.slice(1);
        return <ToggleButton value={o} key={i}>{o === 'ssh-key' ? <span>SSH Key</span> : lowercase ? o : cap}</ToggleButton>
      })}
    </ToggleButtonGroup>
  )
}

export default T



// WEBPACK FOOTER //
// ./src/lib/themes/lingk/ToggleButtonGroup.js